import { apiClient } from './api-client';
import { InviteInfoSchema, type InviteInfo } from '../schemas/auth.schema';
import { SessionSchema, type Session } from '../schemas/user.schema';

export interface JoinInput {
    code: string;
    handle: string;
    pin: string;
}

export const authService = {
    invite: (code: string): Promise<InviteInfo> =>
        apiClient.get(`auth/invite/${encodeURIComponent(code)}`, InviteInfoSchema),

    // noRetry on both: a rejection here means the link or PIN is wrong, and a
    // refresh attempt would replace that with a confusing session error.
    join: (input: JoinInput): Promise<Session> =>
        apiClient.post('auth/join', input, SessionSchema, { noRetry: true }),

    signInWithPin: (userId: number, pin: string): Promise<Session> =>
        apiClient.post('auth/pin', { userId, pin }, SessionSchema, { noRetry: true }),

    logout: (): Promise<void> => apiClient.post('auth/logout'),
};
